import { render, staticRenderFns } from "./BnkVer2.vue?vue&type=template&id=2082c2e7&scoped=true&"
import script from "./BnkVer2.vue?vue&type=script&lang=js&"
export * from "./BnkVer2.vue?vue&type=script&lang=js&"
import style0 from "./BnkVer2.vue?vue&type=style&index=0&id=2082c2e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082c2e7",
  null
  
)

export default component.exports